import { useAppSelector } from "../../../../../store/hooks";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { updateStructureComponent } from "../../../../../store/reducers/builderReducers/structure/structureActions";
import { useEffect, useState } from "react";
import { SectionComponent } from "../../../../_default/interfaces/base";

interface Props {
  id: number;
  triggerResize: () => void;
}

export default function EventsMenu({ id, triggerResize }: Props) {
  console.log("EventsMenu");
  const component = useAppSelector(
    (state) => state.builder.structure.components[id]
  )! as SectionComponent;

  const options = ["%", "px"];

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const isFooter = false;

  useEffect(() => {
    triggerResize();
  }, []);

  useEffect(() => {
    triggerResize();
  }, [isDropdownOpen]);

  function renderFooterWidthOption() {
    if (
      !component.attributes.content_width_size &&
      !component.attributes.content_width_unit
    ) {
      return (
        <input
          type="number"
          style={{ width: "30px" }}
          className="form-input builder-input"
          onChange={(e) => changeProp("content_width_size", e.target.value)}
          value={
            !component.attributes.content_width_size
              ? 100
              : component.attributes.content_width_size
          }
        />
      );
    }

    if (component.attributes.content_width_size) {
      return (
        <input
          type="number"
          style={{ width: "30px" }}
          className="form-input builder-input"
          onChange={(e) => changeProp("content_width_size", e.target.value)}
          value={component.attributes.content_width_size}
        />
      );
    }

    if (component.attributes.content_width_unit === "px") {
      return (
        <input
          type="number"
          style={{ width: "35px" }}
          className="form-input builder-input"
          onChange={(e) => changeProp("content_width_size", e.target.value)}
          value={component.attributes.content_width_size}
        />
      );
    }
  }

  function renderWidthOption() {
    switch (component.attributes.content_width_unit) {
      case "%":
        return (
          <input
            type="number"
            style={{ width: "30px" }}
            className="form-input builder-input "
            onChange={(e) => changeProp("content_width_size", e.target.value)}
            value={
              component.attributes.content_width_size > 100
                ? 100
                : component.attributes.content_width_size
            }
          />
        );
      case "px":
        return (
          <input
            type="number"
            style={{ width: "35px" }}
            className="form-input builder-input"
            onChange={(e) => changeProp("content_width_size", e.target.value)}
            value={component.attributes.content_width_size}
          />
        );
    }
  }

  useEffect(() => {
    renderWidthOption();
  }, [component.attributes]);

  function changeProp(key: string, val: any) {
    updateStructureComponent(id, "attributes." + key, val);
  }

  function changeUnit(unit: "%" | "px") {
    if (component.attributes.content_width_unit === unit) {
      return;
    }

    changeProp("content_width_unit", unit);
    changeProp("content_width_size", unit === "px" ? 1000 : 100);
  }

  return (
    <div className="d-flex flex-wrap align-items-center">
      <div className="b-mx-1 content-width-menu_input">
        <span>
          {isFooter ? renderFooterWidthOption() : renderWidthOption()}
        </span>
      </div>
      <div className="dropup">
        {!isFooter && (
          <span
            onClick={() => {
              setIsDropdownOpen(!isDropdownOpen);
              triggerResize();
            }}
          >
            {component.attributes.content_width_unit}
            <ArrowDropDownIcon
              viewBox="6 6 12 12"
              style={{ fontSize: "11px" }}
            />
          </span>
        )}

        {isFooter && !component.attributes.content_width_unit && (
          <span onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
            {/* {component.attributes.content_width_unit} */}
            <ArrowDropDownIcon
              viewBox="6 6 12 12"
              style={{ fontSize: "11px" }}
            />
          </span>
        )}

        {isFooter && component.attributes.content_width_unit && (
          <span onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
            {component.attributes.content_width_unit}
            <ArrowDropDownIcon
              viewBox="6 6 12 12"
              style={{ fontSize: "11px" }}
            />
          </span>
        )}

        {isDropdownOpen && (
          <div
            style={{
              position: "absolute",
              height: "fit",
              background: "#323232",
              borderRadius: "2px",
            }}
          >
            {options.map((x) => (
              <div
                key={x}
                className={
                  "dropdown-item builder-dropdown__item" +
                  (component.attributes.content_width_unit === x
                    ? " builder-dropdown__item--active"
                    : "")
                }
                onClick={() => changeUnit(x as "%" | "px")}
              >
                {x}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
